<template>
    <div class="operationContainer">
      <h4>{{title}}</h4>
      <slot></slot>
    </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '标题列表'
    }
  },
  methods: {

  }
}
</script>

<style lang="scss">
  .operationContainer {
    display: flex;
    align-items: center;
    margin: 15px 0;
    h4 {
      color: #1eb9a1;
      margin-left: 10px;
      flex-grow: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/operationBar.vue